.root {
    [data-slide-index] {
        width: 100vw;
    }
}

.scrollContainer {
    > * {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 100%;
    }
}

.controls {
    inset-inline: 32px;
}

.dots {
    position: absolute;
    bottom: var(--spacer-24);
    inset-inline: 0;
}
